import { getPayablePoolTokens } from '@ui/constants/tokens';
import { useDataChainId } from '@ui/hooks/datachain';
import { checkIsDesktopUp, useBreakpoint } from '@ui/hooks/useBreakPoint';
import { Token } from '@ui/types/token';
import { useMemo } from 'react';

import { PickerDrawer } from './PickerDrawer';
import { PickerMenu } from './PickerMenu';
import { TokenPickerBaseProps } from './type';

export const TokenPicker = ({
  onSelect,
  children,
  title,
  payableTokens,
}: TokenPickerBaseProps & {
  payableTokens: readonly Token[];
}) => {
  const { value: isDesktopAndUp } = useBreakpoint(checkIsDesktopUp);

  if (isDesktopAndUp) {
    return (
      <PickerMenu
        payableTokens={payableTokens}
        onSelect={onSelect}
        title={title}
      >
        {children}
      </PickerMenu>
    );
  }

  return (
    <PickerDrawer
      payableTokens={payableTokens}
      onSelect={onSelect}
      title={title}
    >
      {children}
    </PickerDrawer>
  );
};
